/* ==========================================================================
   Kuba Acessórios — filtro por modelo + carrinho real (AJAX Cart API).
   Vanilla JS, idempotente (o editor de temas recarrega seções).
   ========================================================================== */
(function () {
  'use strict';
  if (window.__kaLoaded) { window.__kaInit && window.__kaInit(); return; }
  window.__kaLoaded = true;

  var STORE_KEY = 'kuba-acc-model';
  var state = { model: 'todos', cart: null, drawer: false };
  var cfg = { free: 19900, labels: {} };

  /* ---------- utilitários ---------- */
  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  var fmt = null;
  function money(cents) {
    var v = (Number(cents) || 0) / 100;
    if (!fmt) {
      try {
        fmt = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: (state.cart && state.cart.currency) || 'BRL' });
      } catch (e) { fmt = { format: function (n) { return 'R$ ' + n.toFixed(2); } }; }
    }
    return fmt.format(v).replace(/ /g, ' ').replace(/,00$/, '');
  }
  function plural(n, s, p) { return n + ' ' + (n === 1 ? s : p); }
  function tpl(str, vars) {
    return String(str || '').replace(/\{(\w+)\}/g, function (_, k) { return vars[k] != null ? vars[k] : ''; });
  }
  function label(key, fallback) { return cfg.labels[key] != null && cfg.labels[key] !== '' ? cfg.labels[key] : fallback; }

  function readConfig() {
    var el = $('[data-ka-cart-config]');
    if (!el) return;
    try {
      var raw = JSON.parse(el.textContent || '{}');
      cfg.free = Number(raw.free) || 0;
      cfg.labels = raw.labels || {};
    } catch (e) {}
  }

  /* ---------- filtro por modelo ---------- */
  function modelName(id) {
    var chip = $('[data-ka-chip][data-model="' + id + '"]');
    return chip ? (chip.getAttribute('data-name') || chip.textContent.trim()) : '';
  }

  function cardFits(card) {
    if (state.model === 'todos') return true;
    var fits = (card.getAttribute('data-fits') || '').split(',');
    for (var i = 0; i < fits.length; i++) { if (fits[i].trim() === state.model) return true; }
    return false;
  }

  function uniqueKeys(cards) {
    var seen = {}, n = 0;
    cards.forEach(function (c) {
      var k = c.getAttribute('data-key') || c.getAttribute('data-vid') || String(n);
      if (!seen[k]) { seen[k] = 1; n++; }
    });
    return n;
  }

  function applyFilter() {
    var all = $$('[data-ka-card]');
    var visible = [];
    all.forEach(function (card) {
      var show = cardFits(card);
      card.hidden = !show;
      if (show) visible.push(card);
    });

    $$('[data-ka-chip]').forEach(function (c) {
      c.classList.toggle('is-on', c.getAttribute('data-model') === state.model);
      c.setAttribute('aria-pressed', c.getAttribute('data-model') === state.model ? 'true' : 'false');
    });

    var total = uniqueKeys(all);
    var shown = uniqueKeys(visible);
    var name = modelName(state.model);

    $$('[data-ka-filternote]').forEach(function (el) {
      var t = state.model === 'todos' ? el.getAttribute('data-todos') : el.getAttribute('data-filtered');
      el.textContent = tpl(t, { n: shown, total: total, modelo: name });
    });

    $$('[data-ka-list]').forEach(function (sec) {
      var cards = $$('[data-ka-card]', sec);
      var vis = cards.filter(function (c) { return !c.hidden; });
      /* "Destaques": só as 3 primeiras peças que servem no modelo (design: push.filter(fits).slice(0,3)) */
      var max = parseInt(sec.getAttribute('data-ka-max'), 10) || (sec.classList.contains('ka-list--destaque') ? 3 : 0);
      if (max > 0 && vis.length > max) {
        vis.slice(max).forEach(function (c) { c.hidden = true; });
        vis = vis.slice(0, max);
      }
      var cnt = uniqueKeys(vis);

      var counter = $('[data-ka-sec-count]', sec);
      if (counter) {
        var note = counter.getAttribute('data-note') || '';
        if (note) {
          var nm = counter.getAttribute('data-note-model') || '';
          counter.textContent = state.model === 'todos' || !nm ? note : tpl(nm, { modelo: name });
        } else {
          counter.textContent = plural(cnt, counter.getAttribute('data-singular') || 'peça', counter.getAttribute('data-plural') || 'peças');
        }
      }

      var empty = $('[data-ka-sec-empty]', sec);
      if (empty) {
        empty.hidden = cnt > 0;
        if (cnt === 0) empty.textContent = tpl(empty.getAttribute('data-text') || '', { modelo: name });
      }
      var wrap = $('[data-ka-wrap]', sec);
      if (wrap) wrap.hidden = cnt === 0;
    });

    hsUpdate();
    renderSuggestion();
  }

  function setModel(id) {
    state.model = id || 'todos';
    try { localStorage.setItem(STORE_KEY, state.model); } catch (e) {}
    applyFilter();
  }

  /* ---------- scroll horizontal (fade + seta) ---------- */
  function hsUpdate() {
    $$('.ka-hs').forEach(function (w) {
      var sc = $('[data-ka-grid]', w) || w.firstElementChild;
      if (!sc) return;
      var more = sc.scrollWidth - sc.clientWidth - sc.scrollLeft > 12;
      w.setAttribute('data-hs-end', more ? '0' : '1');
    });
  }
  function hsBind() {
    $$('.ka-hs').forEach(function (w) {
      var sc = $('[data-ka-grid]', w) || w.firstElementChild;
      if (!sc || sc.__kaHs) return;
      sc.__kaHs = true;
      sc.addEventListener('scroll', hsUpdate, { passive: true });
    });
  }

  /* ---------- carrinho real ---------- */
  var chain = Promise.resolve();
  function queue(fn) { chain = chain.then(fn).catch(function (e) { console.warn('[kuba-acc]', e); }); return chain; }

  var selfNotify = false;
  function notifyTheme() {
    selfNotify = true;
    try { document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true })); } catch (e) {}
    setTimeout(function () { selfNotify = false; }, 0);
  }

  /* O carrinho também muda fora desta página (drawer do tema, header, outra aba).
     Re-sincroniza sem entrar em laço com o próprio notifyTheme(). */
  function resync() { queue(fetchCart); }
  function bindCartSync() {
    if (document.__kaCartSync) return;
    document.__kaCartSync = true;
    ['cart:refresh', 'cart:updated', 'cart:change', 'cart:build'].forEach(function (name) {
      document.addEventListener(name, function () { if (!selfNotify) resync(); });
    });
    window.addEventListener('pageshow', function (e) { if (e.persisted) resync(); });
    document.addEventListener('visibilitychange', function () { if (!document.hidden) resync(); });
  }

  function fetchCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (c) { state.cart = c; renderCart(); return c; });
  }

  function lineFor(vid) {
    if (!state.cart || !state.cart.items) return null;
    for (var i = 0; i < state.cart.items.length; i++) {
      if (String(state.cart.items[i].variant_id) === String(vid)) return state.cart.items[i];
    }
    return null;
  }

  function addVariant(vid, qty) {
    return fetch('/cart/add.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(vid), quantity: qty || 1 }] })
    }).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'erro'); return j; }); })
      .then(function () { return fetchCart(); })
      .then(function (c) { notifyTheme(); return c; });
  }

  function changeLine(key, qty) {
    return fetch('/cart/change.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); })
      .then(function (c) { state.cart = c; renderCart(); notifyTheme(); return c; });
  }

  function bump(vid, delta) {
    var line = lineFor(vid);
    if (!line) { if (delta > 0) return addVariant(vid, 1); return Promise.resolve(); }
    return changeLine(line.key, Math.max(0, line.quantity + delta));
  }

  function busy(el, on) { if (el) el.classList.toggle('is-busy', !!on); }

  /* ---------- variante escolhida no próprio card ---------- */
  function selectVariant(card, el) {
    if (!card || !el) return;
    var vid = el.getAttribute('data-ka-var') || el.value;
    if (!vid) return;
    var price = el.getAttribute('data-price');
    var avail = el.getAttribute('data-avail') !== 'false';
    card.setAttribute('data-vid', vid);
    if (price) card.setAttribute('data-price', price);
    $$('[data-ka-var]', card).forEach(function (b) { b.classList.toggle('is-on', b === el); });
    var hid = $('input[name="id"]', card);
    if (hid) hid.value = vid;
    var pr = $('[data-ka-price]', card);
    if (pr && price) pr.textContent = money(price);
    var note = $('[data-ka-pricenote]', card);
    if (note) note.hidden = true;
    var btn = $('[data-ka-add]', card);
    if (btn) {
      btn.disabled = !avail;
      var base = btn.getAttribute('data-label-base');
      if (base && price && btn.getAttribute('data-label-price') === '1') {
        btn.setAttribute('data-label-off', base + ' · ' + money(price));
      }
      if (!avail) btn.textContent = btn.getAttribute('data-label-out') || 'Esgotado';
    }
    renderCards();
  }

  /* ---------- render ---------- */
  function renderCards() {
    $$('[data-ka-card][data-vid]').forEach(function (card) {
      var vid = card.getAttribute('data-vid');
      var line = lineFor(vid);
      var q = line ? line.quantity : 0;
      card.classList.toggle('is-on', q > 0);
      var step = $('[data-ka-step]', card);
      if (step) {
        step.hidden = q === 0;
        var out = $('[data-ka-qty]', step);
        if (out) out.textContent = q;
      }
      var btn = $('[data-ka-add]', card);
      if (btn && !btn.disabled) {
        var on = btn.getAttribute('data-label-on') || 'No carrinho';
        var off = btn.getAttribute('data-label-off') || 'Adicionar';
        btn.textContent = q > 0 ? on : off;
      }
    });
  }

  function renderCart() {
    var cart = state.cart || { items: [], item_count: 0, total_price: 0 };
    var count = cart.item_count || 0;
    var total = cart.total_price || 0;
    var free = cfg.free || 0;
    var gap = Math.max(0, free - total);
    var pct = free > 0 ? Math.min(100, (total / free) * 100) : 100;

    var countLabel = plural(count, label('item_s', 'item'), label('item_p', 'itens'));
    var totalLabel = money(total);
    var shipLine = count === 0
      ? tpl(label('ship_zero', 'Frete grátis a partir de {valor}'), { valor: money(free) })
      : gap > 0
        ? tpl(label('ship_gap', 'Faltam {valor} pro frete grátis'), { valor: money(gap) })
        : label('ship_ok', 'Frete grátis garantido');

    var bar = $('[data-ka-bar]');
    if (bar) bar.classList.toggle('is-on', count > 0);
    $$('[data-ka-ship]').forEach(function (e) { e.textContent = shipLine; });
    $$('[data-ka-meta]').forEach(function (e) { e.textContent = countLabel + ' · ' + totalLabel; });
    $$('[data-ka-countlabel]').forEach(function (e) { e.textContent = countLabel; });
    $$('[data-ka-total]').forEach(function (e) { e.textContent = totalLabel; });
    $$('[data-ka-fill]').forEach(function (e) { e.style.width = pct + '%'; });
    $$('[data-ka-cta]').forEach(function (e) {
      e.textContent = tpl(label('bar_cta', 'Ver {itens} · {total}'), { itens: countLabel, total: totalLabel });
    });

    var list = $('[data-ka-items]');
    if (list) {
      list.innerHTML = '';
      cart.items.forEach(function (it) {
        var row = document.createElement('div');
        row.className = 'ka-li';
        row.setAttribute('data-key', it.key);
        var img = it.image ? '<img class="ka-li__img" src="' + it.image.replace(/(\.[a-z]+)(\?|$)/i, '_112x112$1$2') + '" alt="" loading="lazy" width="56" height="56">' : '<span class="ka-li__img"></span>';
        row.innerHTML = img +
          '<span class="ka-li__txt"><span class="ka-li__name"></span><span class="ka-li__line"></span></span>' +
          '<span class="ka-li__step"><button type="button" data-ka-li-minus aria-label="Menos um">−</button><span>' + it.quantity + '</span><button type="button" data-ka-li-plus aria-label="Mais um">+</button></span>';
        $('.ka-li__name', row).textContent = it.product_title || it.title;
        var variantPart = it.variant_title && it.variant_title !== 'Default Title' ? it.variant_title + ' · ' : '';
        $('.ka-li__line', row).textContent = variantPart + it.quantity + ' × ' + money(it.price);
        list.appendChild(row);
      });
    }
    var empty = $('[data-ka-cartempty]');
    if (empty) empty.hidden = count > 0;

    renderCards();
    renderSuggestion();
  }

  function renderSuggestion() {
    var box = $('[data-ka-sug]');
    if (!box) return;
    var cart = state.cart || { item_count: 0, total_price: 0 };
    var count = cart.item_count || 0;
    var gap = Math.max(0, (cfg.free || 0) - (cart.total_price || 0));
    if (count === 0 || gap === 0) { box.hidden = true; return; }

    var best = null;
    $$('[data-ka-card][data-vid][data-price]').forEach(function (card) {
      if (card.hidden) return;
      var price = Number(card.getAttribute('data-price')) || 0;
      if (price < gap) return;
      if (lineFor(card.getAttribute('data-vid'))) return;
      if (!best || price < best.price) best = { price: price, vid: card.getAttribute('data-vid'), name: card.getAttribute('data-name') || '' };
    });
    if (!best) { box.hidden = true; return; }

    box.hidden = false;
    box.setAttribute('data-vid', best.vid);
    $('[data-ka-sug-gap]', box).textContent = tpl(label('gap_label', 'Faltam {valor}'), { valor: money(gap) });
    $('[data-ka-sug-name]', box).textContent = best.name;
    $('[data-ka-sug-line]', box).textContent = tpl(label('sug_line', '{valor} · fecha a conta e o frete sai de graça.'), { valor: money(best.price) });
  }

  /* ---------- gaveta ---------- */
  function setDrawer(on) {
    state.drawer = !!on;
    var d = $('[data-ka-drawer]'), s = $('[data-ka-scrim]');
    if (d) { d.classList.toggle('is-on', state.drawer); d.setAttribute('aria-hidden', state.drawer ? 'false' : 'true'); }
    if (s) s.classList.toggle('is-on', state.drawer);
  }

  /* Sem a barra própria (seção kuba-acc-carrinho desligada), o "Adicionar" abre a gaveta padrão do tema. */
  function openThemeCart() {
    if ($('[data-ka-bar]')) return;
    var d = document.getElementById('CartDrawer');
    if (!d) return;
    if (typeof d.openDialog === 'function') d.openDialog();
    else { var a = document.querySelector('a[aria-controls="CartDrawer"]'); if (a) a.click(); }
  }

  /* ---------- eventos (delegados, ligados uma vez) ---------- */
  function bindOnce() {
    if (document.__kaBound) return;
    document.__kaBound = true;

    document.addEventListener('click', function (ev) {
      var t = ev.target;
      if (!t || !t.closest) return;
      var el;

      if ((el = t.closest('[data-ka-chip]'))) { ev.preventDefault(); setModel(el.getAttribute('data-model')); return; }

      if ((el = t.closest('[data-ka-var]'))) {
        ev.preventDefault();
        if (el.disabled) return;
        selectVariant(el.closest('[data-ka-card]'), el);
        return;
      }

      if ((el = t.closest('[data-ka-add]'))) {
        if (el.disabled || el.tagName === 'A') return;
        ev.preventDefault();
        var card = el.closest('[data-ka-card]');
        var vid = card && card.getAttribute('data-vid');
        if (!vid) return;
        busy(el, true);
        queue(function () { return bump(vid, 1).then(function () { busy(el, false); openThemeCart(); }, function () { busy(el, false); }); });
        return;
      }

      if ((el = t.closest('[data-ka-plus],[data-ka-minus]'))) {
        ev.preventDefault();
        var c = el.closest('[data-ka-card]');
        var v = c && c.getAttribute('data-vid');
        if (!v) return;
        var d = el.hasAttribute('data-ka-plus') ? 1 : -1;
        queue(function () { return bump(v, d); });
        return;
      }

      if ((el = t.closest('[data-ka-li-plus],[data-ka-li-minus]'))) {
        ev.preventDefault();
        var row = el.closest('[data-key]');
        if (!row) return;
        var key = row.getAttribute('data-key');
        var line = (state.cart && state.cart.items || []).filter(function (i) { return i.key === key; })[0];
        if (!line) return;
        var nq = line.quantity + (el.hasAttribute('data-ka-li-plus') ? 1 : -1);
        queue(function () { return changeLine(key, Math.max(0, nq)); });
        return;
      }

      if ((el = t.closest('[data-ka-sug-add]'))) {
        ev.preventDefault();
        var box = el.closest('[data-ka-sug]');
        var sv = box && box.getAttribute('data-vid');
        if (sv) queue(function () { return bump(sv, 1); });
        return;
      }

      if (t.closest('[data-ka-open]')) { ev.preventDefault(); setDrawer(true); return; }
      if (t.closest('[data-ka-close]')) { ev.preventDefault(); setDrawer(false); return; }
    });

    document.addEventListener('submit', function (ev) {
      var form = ev.target && ev.target.closest ? ev.target.closest('form') : null;
      if (!form) return;
      var card = form.closest('[data-ka-card]');
      var vid = card && card.getAttribute('data-vid');
      if (!vid) return;
      ev.preventDefault();
      queue(function () { return bump(vid, 1).then(openThemeCart); });
    });

    document.addEventListener('change', function (ev) {
      var sel = ev.target && ev.target.closest ? ev.target.closest('[data-ka-sel]') : null;
      if (!sel) return;
      selectVariant(sel.closest('[data-ka-card]'), sel.options[sel.selectedIndex]);
    });

    document.addEventListener('keydown', function (ev) { if (ev.key === 'Escape' && state.drawer) setDrawer(false); });
    window.addEventListener('resize', hsUpdate);
  }

  /* ---------- init ---------- */
  function init() {
    if (!$('[data-ka-card]') && !$('[data-ka-bar]') && !$('[data-ka-chip]')) return;
    readConfig();
    try {
      var m = localStorage.getItem(STORE_KEY);
      if (m && $('[data-ka-chip][data-model="' + m + '"]')) state.model = m;
    } catch (e) {}
    bindOnce();
    bindCartSync();
    hsBind();
    applyFilter();
    if (state.cart) renderCart(); else queue(fetchCart);
  }
  window.__kaInit = init;

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', function () { setTimeout(init, 50); });
})();
